import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily: '"Montserrat", Arial, Helvetica, sans-serif',
  },
  palette: {
    primary: {
      main: '#4a148c',
    },
    secondary: {
      light: '#7c43bd',
      main: '#7c43bd',
    },
  },
  overrides: {
    MuiAppBar: {
      root: {
        height: '2.5em',
      },
    },
    MuiToolbar: {
      dense: {
        minHeight: '0.75em',
        paddingBottom: '0.5em',
      },
    },
    MuiInputAdornment: {
      root: {
        color: 'white',
      },
    },
  },
});

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <App />
  </MuiThemeProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
